module.exports = __webpack_public_path__ + "img/bake-rolls.db09141a.svg";